<template>
  <!-- <div style="background: #f9f9f9" :style="{ height: parkHeight }"> -->
  <div style="background: #f9f9f9" :style="{ height: parkHeight }">
    <div class="tittle flex">
      <div class="logo fl">
        <img
          src="../../assets/logo.png"
          alt=""
          @click="getRegisteredLogin(1)"
        />
      </div>
      <div class="login flex">
        <div class="lh90" @click="getRegisteredLogin(1)">首页</div>
        <div class="lh90" @click="getRegisteredLogin(2)">帮助中心</div>
      </div>
    </div>

    <div style="height: 116px"></div>
    <div class="registered">
      <div class="registeredTop flex">
        <!--<h3>发布成功</h3>-->
      </div>
      <div class="regBox">
        <p class="el-icon-circle-check regIcon"></p>
        <!--<p class="regSuccess">发布成功</p>-->
        <p class="regUsername">恭喜您，订单提交成功！</p>
        <p class="regTel">订单编号：<span style="color:#157efb">{{ orderCode }}</span> </p>
        <div class="regButton">
          <button @click="getReturngo(1)">前往买家中心查看订单</button>
          <button @click="getReturngo(2)">返回首页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getNewcurrent } from "../../utils/interface";

export default {
  //  发布成功
  name: "regSuccess",
  data() {
    return {
      userMessages: {},
      orderCode:"",
      uuid:"",
    };
  },
  created() {
    this.orderCode = this.$route.params.orderCode;
    this.parkHeight = document.documentElement.clientHeight + "px";
    this.vuexAllPark(false);
  },
  watch: {},
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    getNewcurrent()
      .then((res) => {
        // console.log("用户信息", res);
        this.userMessages = res;
        // this.userName = res.name;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    ...mapMutations(["vuexAllPark", "isLoginVuex"]),
    // 顶部跳转
    getRegisteredLogin(num) {
      if (num == 1) {
        this.$router.push("/");
      }else if (num == 2){
        this.$router.push("/helpCenter");
      }
    },
    getReturngo(num) {
      if (num == 2) {
        this.$router.push("/");
      } else if (num == 1) {
        let routeData = "";
        // 修改到列表页
        routeData = this.$url.buyerWeb + "#/mallOrderList";
        if(routeData!="") {
          window.open(routeData, "_blank");
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
.red {
  color: #d60000;
}
.registered {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  .registeredTop {
    border-bottom: 1px solid #f9f9f9;
    padding: 18px 30px 18px 44px;
    align-items: center;
    justify-content: space-between;
    // margin: 40px 0;
    span {
      cursor: pointer;
    }
  }
}
.regBox {
  text-align: center;
  padding: 150px 0;
  color: #555;
  .regIcon {
    font-size: 72px;
    margin-bottom: 10px;
    color: #4fc700;
  }
  .regSuccess {
    font-size: 36px;
    margin-bottom: 23px;
  }
  .regUsername {
    margin-bottom: 10px;
  }
  .regMess {
    margin: 55px 0 28px 0;
    font-size: 20px;
  }
  .regButton {
    margin-top: 40px;
    button {
      padding: 7px 30px;
      cursor: pointer;
    }
    button:nth-child(1) {
      border: 1px solid #157efb;
      background: #fff;
      color: #157efb;
      margin-right: 90px;
    }
    button:nth-child(2) {
      border: none;
      background: #157efb;
      color: #fff;
    }
  }
}
.tittle {
  position: fixed;
  background: #fff;
  box-shadow: 0 -1px 0 #f0f0f0 inset;
  width: 100%;
  height: 80px;
  z-index: 9999;
  justify-content: space-around;
  align-items: center;
  .logo {
    // margin: 19px 42px 0 38px;
    align-items: center;
    justify-content: center;
    display: flex;
    flex: 1;
    img {
      height: 50px;
      margin: 8px 0 0 0;
      padding: 0;
    }
  }
}

.login {
  justify-content: center;
  align-items: center;
  flex: 1;
  .lh90 {
    cursor: pointer;
    font-size: 15px;
  }
  .lh90:nth-last-child(1) {
    margin-left: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect/shopSendSuccess.vue